<template>
  <!-- 人物特征 -->
  <div class="border-t">
    <div class="flex flex-col gap-2 px-4">
      <ul class="px-4 py-3 border border-my-dark flex gap-4">
        <template v-if="reqData.mates?.length">
          <li
            v-for="(item, idx) in reqData.mates"
            class="text-center flex flex-col gap-2.5 justify-center items-center relative"
            @click="clickSwitchMate(item)"
          >
            <div
              :class="[
                'w-12 aspect-[3/4] rounded overflow-hidden border',
                activeMate?.id === item.id
                  ? 'border-primary'
                  : 'border-transparent',
              ]"
            >
              <BaseImg
                :url="trait.traitMap[item.id!]!.mediaUrl || trait.traitMap[item.id!].media?.url ||trait.traitMap[item.id!]!.source?.url"
                :media="trait.traitMap[item.id!].media"
                :width="80"
                ratio="3/4"
                alt=""
              />
            </div>
            <p
              :class="[
                'max-w-[50px] text-ellipsis whitespace-nowrap overflow-hidden text-xs',
                activeMate?.id === item.id
                  ? 'text-primary'
                  : ' text-base-content/50',
              ]"
            >
              {{ trait.traitMap[item.id!]!.name }}
            </p>
            <i
              @click.stop="clickRemoveMate(item, idx)"
              class="iconfont icon-xmark absolute right-[-6px] top-[-6px] bg-primary rounded-full text-xs"
            />
          </li>
          <li
            class="text-center flex flex-col gap-2.5 items-center"
            @click="showAddMate = true"
          >
            <div
              class="w-12 aspect-[3/4] flex justify-center items-center bg-primary rounded"
            >
              <i class="iconfont icon-a- text-xs"></i>
            </div>
            <p class="text-xs">
              {{ t(`painting.muti.addMate`) }}
            </p>
          </li>
        </template>
        <div v-else class="mx-auto my-8">
          <button class="btn btn-primary" @click="showAddMate = true">
            {{ t(`painting.muti.addMate`) }}
          </button>
        </div>
      </ul>

      <!-- 人物 -->
    </div>
    <template v-if="activeMate">
      <EditPrompts
        mode="multi_single"
        v-model:prompt="activeMate.pose.prompt"
        v-model:negative-prompt="activeMate.pose.negativePrompt"
      />
    </template>
  </div>

  <CreateTraitPresetModal v-model:show="showCreateTraitModal" />

  <ImageModalAddMate
    v-if="reqData.mates"
    v-model:show="showAddMate"
    @select-trait="onAddTrait"
    :filter-ids="reqData.mates.map((v) => v.id)"
  />
</template>

<script lang="ts" setup>
import { getInitTraitPromptJson } from "@/modules/common";
import { useMateTrait } from "@/stores/mateTrait";
import { showConfirmDialog } from "vant";
import { ref, PropType, watch, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { initStyle } from "./initStyle";
import { useRoute } from "vue-router";

const props = defineProps({
  reqData: {
    type: Object as PropType<PromptJson>,
    required: true,
  },
});
const emit = defineEmits(["update:selectTrait"]);

const trait = useMateTrait();
const route = useRoute();
const { t } = useI18n();

const showCreateTraitModal = ref(false);

// 人物特征
const selectedTrait = ref<MateTrait | null>();
const showCharacterEditModal = ref(false);
// 选择特征
const matePrompt = ref("");
const clickSelectedTrait = (trait: MateTrait | null) => {
  selectedTrait.value = trait;
  matePrompt.value = trait?.prompt ?? "";
};

watch(matePrompt, (val) => (activeMate.value!.prompt = val || ""));

watch(selectedTrait, (val) => (activeMate.value!.id = val?.id || undefined));

// mates

// activeMate...
const showAddMate = ref(false);
const activeMate = ref<PromptJsonMateTrait>();
const clickSwitchMate = (trait: PromptJsonMateTrait) => {
  activeMate.value = trait;
};

const clickRemoveMate = async (trait: PromptJsonMateTrait, idx: number) => {
  try {
    await showConfirmDialog({
      message: t(`Message.deleteConfirm`),
      confirmButtonText: t("Buttons.confirm"),
      cancelButtonText: t("Buttons.cancel"),
    });
  } catch (e) {
    return;
  }
  props.reqData.mates!.splice(idx, 1);
  if (activeMate.value?.id === trait.id) {
    activeMate.value = props.reqData.mates![0];
  }
};

const onAddTrait = (trait: MateTrait) => {
  const { prompt, id, style, mixStyle, customStyle } = trait;
  props.reqData.mates!.push({
    id,
    prompt,
    ...getInitTraitPromptJson(),
  });
  activeMate.value = props.reqData.mates![props.reqData.mates!.length - 1];
  if (
    ([6, 9].includes(Number(route.query.mode)) &&
      (!customStyle?.version || customStyle.version !== 1)) ||
    ([2, 3, 4].includes(Number(route.query.mode)) &&
      (!customStyle || customStyle.version === 0))
  ) {
    props.reqData.style = undefined;
    props.reqData.mixStyle = [];
    props.reqData.customStyle = {
      version: 1,
      prompt: customStyle?.prompt || "",
    };
  } else initStyle(props.reqData, style, customStyle, mixStyle);
  // initStyle(props.reqData, style, customStyle, mixStyle);
};

onMounted(async () => {
  if (props.reqData.mates && props.reqData.mates.length > 0) {
    activeMate.value = props.reqData.mates![0];
  }
  if (activeMate.value?.id) {
    selectedTrait.value = await trait.getOrFetchTraitItem(activeMate.value!.id);
    matePrompt.value =
      activeMate.value!.prompt ?? selectedTrait.value?.prompt ?? "";
  }
});
</script>
